import { I18n } from "@aws-amplify/core";
import { get, size, filter, includes } from "lodash";

import { fetchGet, fetchPost } from "../api/fetch";

export const validateEmail = (email) => {
  let regex = /[\w-.]+@([\w-]+\.)+[\w-]{2,4}/;
  return regex.test(email);
};

export const validatePhone = (phone) => {
  let regex = /\d{10}/;
  return regex.test(phone);
};

export const formatPhone = (phone) => {
  if (!phone) {
    return "";
  }
  let pattern = "###-###-####";
  let value = phone.toString();
  pattern = pattern.substring(
    0,
    value.length < 4
      ? value.length
      : value.length < 7
        ? value.length + 1
        : value.length < 11
          ? value.length + 2
          : pattern.length
  );
  let i = 0;
  return pattern.replace(/#/g, (_) => {
    let res = value[i];
    i += value[i + 1] !== "-" ? 1 : 2;
    if (res && !isNaN(res)) {
      return res;
    }
    return "";
  });
};

export const formatNumber = (value) => {
  if (!isNaN(value)) {
    return parseInt(value);
  }
  if (value.length > 1) {
    return parseInt(value.substr(0, value.length - 1));
  }
  return "";
};

export const validateNumber = (value) => {
  let regex = /\d*/;
  return regex.test(value);
};

export const validateSingleField = async (
  id,
  value,
  required,
  validationLevel,
  profileId
) => {
  let valid = false;
  let error;
  if (!value && !required) {
    valid = true;
  } else if (!value && required) {
    valid = false;
    error = I18n.get("users_requiredField");
  } else {
    if (includes([195], id)) valid = validateEmail(value);
    if (includes([34], id)) valid = validatePhone(value);
    if (includes([37, 38], id)) valid = validateNumber(value);

    if (!valid) {
      error = I18n.get("profiles_formatInvalid");
    } else if (includes([37, 38], id)) {
      if (id === 37) {
        try {
          await fetchPost("sys/profiles/rfid", {
            rfid: value,
          });
          valid = false;
          error = I18n.get("profiles_rfidAlreadyInUse");
        } catch (e) {
          valid = true;
          error = null;
        }
      } else if (id === 38) {
        try {
          await fetchGet(`profiles/barcode/${value}`);
          valid = false;
          error = I18n.get("profiles_barcodeAlreadyInUse");
        } catch (e) {
          valid = true;
          error = null;
        }
      }
    } else if (includes(["no-duplicates", "duplicate-warn"], validationLevel)) {
      try {
        let valueExists;
        if (id === 195) {
          valueExists = await fetchPost("profiles/search/email", {
            email: value,
            profile_type: 1,
          });
        } else if (id === 34) {
          valueExists = await fetchPost("profiles/search/phone", {
            phone: value.toString(),
            profile_type: 1,
          });
        }

        if (
          valueExists.count === 0 ||
          size(
            filter(get(valueExists, ["profiles"]), (p) => p.id !== profileId)
          ) === 0
        ) {
          valid = true;
          error = null;
        } else {
          valid = validationLevel === "no-duplicates" ? false : true;
          error = I18n.get(
            id === 195
              ? "profiles_emailAlreadyInUse"
              : id === 34
                ? "profiles_phoneAlreadyInUse"
                : ""
          );
        }
      } catch (e) {
        console.log(e);
        valid = false;
      }
    }
  }
  return [valid, error];
};
